import axios from "axios";
import baseUrl from "./baseUrl";

export default class PermissionaryApi {
	static resourceUrl = baseUrl + "/permissionary-management";

	static async getPermissionariesByUserId(data: {
		userId: string;
		token: string | null;
	}): Promise<any> {
		const { userId, token } = data;

		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/by-user/" + userId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	static async getOnePermissionary(data: {
		query: {};
		token: string | null;
	}): Promise<any> {
		const { query, token } = data;

		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/get-one?q=" + JSON.stringify(query),
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}
}
